import React, { useState } from "react";
import { Container, Button, Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import axios from "axios";
import { API_BASE_URL, ALTACARTAPDF, RUTACARTAPDF } from '../services/apiConfig';

function Carta() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const [selectedFile, setSelectedFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Verifica si el archivo es un PDF
    if (file && file.type !== "application/pdf") {
      setError('Por favor, selecciona un archivo PDF.');
    } else {
      setError('');
      setSelectedFile(file);
    }
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      setError('Por favor, selecciona un archivo PDF.');
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true); // Comienza la subida del archivo

    try {
      const response = await axios.post(API_BASE_URL + ALTACARTAPDF, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Archivo subido:", response);
      setPdfUrl(response.data.url); // Guarda la URL del PDF subido
      setError('');
      setSuccessMessage('¡El archivo se subió exitosamente!');
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      setError('Hubo un error al subir el archivo.');
    } finally {
      setIsUploading(false); // Finaliza la subida del archivo
    }
  };


  return (
    <Container maxWidth={isMobile ? false : "xl"} sx={{ px: isMobile ? 1 : 3 }}>
      <MenuInicial />
      
      <Box mt={4} display="flex" flexDirection="column" alignItems="center">
        <Box mb={2}>
          <input type="file" style={{ display: 'none' }} accept="application/pdf" onChange={handleFileChange} id="upload-file" />
          <label htmlFor="upload-file">
            <Button variant="contained" component="span">
              Examinar
            </Button>
          </label>
        </Box>
        {selectedFile && <p>Archivo seleccionado: {selectedFile.name}</p>}
        <Button variant="contained" color="primary" onClick={handleFileUpload}>
          Subir PDF
        </Button>
        {isUploading && <CircularProgress style={{ marginTop: '8px' }} />}
        {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
        {successMessage && <div style={{ color: 'green', marginTop: '8px' }}>{successMessage}</div>}
      </Box>

      {RUTACARTAPDF && (
        <Box mt={4} display="flex" justifyContent="center">
          <Button variant="outlined" color="primary" href={RUTACARTAPDF} target="_blank" rel="noopener noreferrer">
            Ver PDF
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default Carta;
